import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Actions, ofType} from '@ngrx/effects';
import {RoutingService, TranslationService, WindowRef} from '@spartacus/core';
import {Subscription} from 'rxjs';

import {AimoCart} from '../../../model/cart.model';
import {AimoProduct} from '../../../model/product.model';
import {AimoActiveCartService} from '../../../service/cart/aimo-active-cart.service';
import {AIMO_CART_UPDATE_HEADER_SUCCESS} from '../../../service/cart/aimo-cart.action';
import {AimoGTMProductAttributes, GTMCartType, GTMItemListId} from '../../../service/gtm/aimo-gtm.model';
import {AimoGtmService} from '../../../service/gtm/aimo-gtm.service';
import {AimoProductService} from '../../../service/product/aimo-product.service';
import {DateUtils} from '../../../shared/util/date-utils';

@Component({
    selector: 'aimo-order-history-order',
    templateUrl: './aimo-order-history-order.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderHistoryOrderComponent implements OnDestroy, OnInit {
    @Input()
    order: AimoCart;

    private subscriptions = new Subscription();
    invoices: string[];

    constructor(
        protected activeCartService: AimoActiveCartService,
        protected windowRef: WindowRef,
        protected actions$: Actions,
        protected routingService: RoutingService,
        protected translation: TranslationService,
        protected productService: AimoProductService,
        protected gtmService: AimoGtmService,
    ) {
        this.subscriptions.add(
            this.actions$
                .pipe(ofType(AIMO_CART_UPDATE_HEADER_SUCCESS))
                .subscribe(() => this.routingService.go('/cart')),
        );
    }

    ngOnInit(): void {
        this.invoices = Array.from(
            new Set(this.order.entries.map((e) => e.invoiceDocumentNumber).filter((n) => n !== undefined)),
        );
        let idx = 0;
        this.productService.fireProductListViewGtmEvent(
            this.order.entries?.map((e) => ({
                ...e.product,
                gtmProductAttributes: this.createGtmAttributes(e.product, idx++)
            }))
        );
    }

    createGtmAttributes(product: AimoProduct, index: number): AimoGTMProductAttributes {
        return {
            ...this.gtmService.createProductGtmAttributesBase(product, GTMItemListId.order_history),
            index: index,
            cart_type: GTMCartType.cart,
        } as AimoGTMProductAttributes;
    }

    downloadInvoice(invoiceId: string, name: string): void {
        this.translation
            .translate(name, {id: invoiceId})
            .subscribe((t) => this.activeCartService.downloadOrderDocument(invoiceId, t, false))
            .unsubscribe();
    }

    convertDate(d: string): Date {
        return DateUtils.convertDate(d);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    payNow(code: string): void {
        this.routingService.go('/cart', {queryParams: {payNow: code}});
    }
}
